<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-26 
-->
<template>
  <div>
    <van-popup v-model="modelIndex" position="bottom" round @close="resetForms">
      <div class="login-view">
        <div class="view-top">
          <div class="container-title">{{'更新手机号' | dealLanguage('Update phone number')}}</div>
          <img :src="static_img_url+'pic/vbef.png?v=' + $store.state.imgVersion" />
        </div>
        <div class="view-container">
          <Form ref="update-form" :model="updateMobileForm" :rules="ruleValidate">
            <FormItem prop="mobile" :label="'手机号' | dealLanguage('Phone Number')">
              <div class="mobile-ipt">
                <span class="area-number" @click="showPicker = true">+{{loginNumber.mobileAreaCode}} &gt;</span>
                <Input type="text" v-model="updateMobileForm.mobile" :placeholder="'请输入手机号' | dealLanguage('Please enter mobile phone number')" autocomplete="off"></Input>
              </div>
            </FormItem>
            <FormItem v-if="ncStatus">
              <div class="nc-cnt">
                <div id="nc"></div>
              </div>
            </FormItem>
            <FormItem prop="code" :label="'验证码' | dealLanguage('Phone Code')">
              <Input class="code-ipt" type="text" v-model="updateMobileForm.code" :placeholder="'请填写验证码' | dealLanguage('Please fill in the verification code')" autocomplete="off"></Input>
              <Captcha
                ref="captcha"
                scene="vbdata_bidingmobile"
                :mobile="updateMobileForm.mobile"
                :mobileAreaCode="loginNumber.mobileAreaCode"
                v-if="modelIndex"
              ></Captcha>
            </FormItem>
          </Form>
          <p class="tip">{{'未注册的手机号将自动创建动脉网账号' | dealLanguage('Unregistered mobile phone numbers will automatically create an VBEF account')}}</p>
          <van-button type="primary" block @click="updateMobile">{{'保存' | dealLanguage('Save')}}</van-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker :default-index="defaultIndex" show-toolbar :columns="appMobileAreaCodeDtos" @confirm="onConfirm" @cancel="showPicker = false" value-key="name">
        <template #option="item">
          <div>+{{item.mobileAreaCode}} ({{item.countryName | dealLanguage(item.countryEnName)}})</div>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>
<script>
import { Aaccountbinding } from '@/service/app'
import { loginCommon } from '@/assets/js/login'
import { mapState } from 'vuex'
import filter from 'js/filter'
import Captcha from '@/components/common/captcha'
export default {
  mixins: [loginCommon],
  inject: ['reload'],
  components: { Captcha },
  created() {
    // this.updateRuleValidate()
  },
  mounted() {},
  data() {
    return {
      modelIndex: false,
      updateMobileForm: {
        mobile: '',
        code: '',
      },
      showPicker: false,
      loginNumber: {
        id: 1,
        mobileAreaCode: '86',
        countryName: '中国',
        countryEnName: 'China'
      }
    }
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
    }),
  },
  methods: {
    onConfirm(item) {
      this.loginNumber = { ...item }
      this.showPicker = false
      // this.updateRuleValidate()
    },
    resetForms() {
      this.$refs['update-form'].resetFields()
      this.loginNumber = {
        ...{
          id: 1,
          mobileAreaCode: '86',
          countryName: '中国',
          countryEnName: 'China'
        },
      }
      this.codeStatus = 0
      this.wait = 60
      clearInterval(this.waitInterval)
    },
    updateMobile() {
      this.$refs['update-form'].validate(async (valid) => {
        if (valid) {
          let user = { ...this.$store.state.user }
          let res = await Aaccountbinding({
            code: this.updateMobileForm.code,
            mobile: this.updateMobileForm.mobile,
            mobileAreaCode: this.loginNumber.mobileAreaCode,
            type: 4,
            loginPlatform: 9,
            xuser: user,
          })
          if (res.code == 0) {
            user.mobile = this.updateMobileForm.mobile
            user.mobileAreaCode = this.loginNumber.mobileAreaCode
            this.$store.commit('updateUser', user)
            this.$notify({ type: 'success', message: this.language == 'zh' ? '更新成功！' : 'Update successful!' })
            this.$emit('updateMobileSuccess', user)
            this.modelIndex = false
          } else {
            this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
          }
        }
      })
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/login-m.styl'
</style>